import { render, staticRenderFns } from "./DistanceFromUserData.vue?vue&type=template&id=5db18c1c&scoped=true&lang=html&"
import script from "./DistanceFromUserData.vue?vue&type=script&lang=js&"
export * from "./DistanceFromUserData.vue?vue&type=script&lang=js&"
import style0 from "./DistanceFromUserData.vue?vue&type=style&index=0&id=5db18c1c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db18c1c",
  null
  
)

export default component.exports